import { ISelectedDestination } from '../../types';

export const getChannel = (channel: string, selectedDestinations: ISelectedDestination[]): ISelectedDestination[] => {
  return selectedDestinations.filter((destination) => destination.channel === channel);
};
